
import { Transition } from "../../../../core/flows/Transition";
import { FmlmViewContext } from "../../../FmlmDetail/Context/FmlmViewContext";
import { SearchContext } from "../Context/SearchContext";

export class SearchTransition extends Transition {
  constructor(entryStep: string, exitSteps: string[]) {
    super(entryStep, exitSteps);
  }

  onExecute(): string[] {
    const context = this.getCtx<SearchContext>("searchContext", this.entryStep);
    if (!context) {
      console.log("[Transition] No choice data available, using default exits");
      return this.exitSteps;
    }

    if (context.routeTo.includes("FmlmViewFlow")) {
      context.routeTo = context.routeTo;

      const fmlmViewContext = new FmlmViewContext();
      this.setCtx<FmlmViewContext>("fmlmViewContext", fmlmViewContext, this.entryStep);
    }

    if (!(context.routeTo ?? []).every((step) => this.exitSteps.includes(step))) {
      console.log(`[Transition] Invalid choice: ${context.routeTo}`);
      return [];
    }

    return [...(context?.routeTo ?? [])];
  }
}